import "./App.css";
import "antd/dist/antd.css";
import { Form, Input, Button, Modal, Spin } from "antd";
import { useEffect, useRef, useState } from "react";
import { api, googleRecaptchaConfig } from "./settings";
import VideoSection from "./components/videoSection";
import "./App.scss";
import _24e from "./assets/img/24e.png";
import alex from "./assets/img/alex.png";
import ally from "./assets/img/ally.png";
import percy from "./assets/img/percy.png";
import _24e_white from "./assets/img/24e_white.png";
import bcp from "./assets/img/bcp.png";
import efut from "./assets/img/efut.png";
import { LoadingOutlined } from '@ant-design/icons';
import Recaptcha from 'react-recaptcha';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-180759555-1');
ReactGA.pageview(window.location.pathname);

const antIcon = 
  <LoadingOutlined 
    style={{ fontSize: 50 }} 
    spin />;

const parseUrlQuery = (value) => {
  if (value.search) {
    var paramsAr = value.search.split('=');
    var code = paramsAr[1]
    return code
  } else {
    return ''
  }
}

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2]);
}

function App() {
  const _isMounted = useRef(false)
  const recaptchaRef = useRef();
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setShowContent(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    let localShowContent = localStorage.getItem("show_content");
    if (localShowContent !== null && localShowContent === "true") {
      setShowContent(true);
    } else {
      loadByEmail()
    }

    //campaign data
    if (getParameterByName('utm_source')) {
      form.setFieldsValue({
        utm_source: getParameterByName('utm_source'),
        utm_campaign: getParameterByName('utm_campaign'),
        utm_keyword: getParameterByName('utm_keyword'),
        utm_medium: getParameterByName('utm_medium'),
      });
    }

    return () => {
      _isMounted.current = true
    }
  }, [showContent, form]);

  const loadByEmail = () => {
    let codeParam = getParameterByName('code')
    
    if (codeParam) {
      setLoading(true);
      var apiParams = {
        code: codeParam,
      }
      api.get('persona/getEmail', { params: apiParams })
      .then(res => res.data)
      .then(res => {
        if (res.success) {
          localStorage.setItem('email', res.email);
          localStorage.setItem('show_content', true);
          setShowContent(true);
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
    }
  }

  const onFinish = (values) => {
    //setShowContent(true);
    //if (isVerified) {
    setLoadingSubmit(true);
    let apiParams = values;
    api.post('persona/register', apiParams)
    .then(res => res.data)
    .then(res => {
      if (res.success) {
        showModal()
        localStorage.setItem('show_content', true);
        localStorage.setItem('email', form.getFieldValue('email'))
      }
      setLoadingSubmit(false);
    })
    .catch(error => {
      setLoadingSubmit(false);
    });
    /*} else {
      notification['error']({
        message: 'Por favor complete la prueba de seguridad'
      });
      return
    }
    */
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const verifyCallback = response => {
    if (!_isMounted.current) {
      if (response) {
        form.setFieldsValue({
          recaptcha: response,
        })
        setIsVerified(true)
      }
    }
  }

  const expiredCallback = () => {
    setIsVerified(false)
    form.setFieldsValue({
      recaptcha: null,
    })
  }

  function onChange(value) {
    //custom fetch and at the end do a reset
    if (recaptchaRef && recaptchaRef.current && recaptchaRef.current.reset) {
      recaptchaRef.current.reset()
    }
  }

  return (
    <>
      <div className="section-main section-colors-white">
        <div className="header">
          <div className="content-padding">
            <div className="header-data">
              <div className="logo1">
                  <img src={_24e_white} alt="" />
              </div>
              <div className="logo2">
                  <img src={efut} alt="" />
              </div>
              <div className="logo3">
                  <img src={bcp} alt="" />
              </div>
            </div>
          </div>
        </div>
        
        {loading?
          <Spin indicator={antIcon} className="loading-spin" />:
        !showContent ? (
          <div className="content-padding">
            <div className="data-info-main">
              <h3 className="h3-title full-width-xs">
                Cómo AUMENTAR TUS VENTAS durante las Fiestas de Fin de Año y la
                próxima gestión!&nbsp;🎉
              </h3>

              <div className="expositores full-width-xs">
                <div className="item-expositor">
                  <div className="img-item-expositor">
                    <img src={percy} alt="" />
                  </div>
                  <h4 className="title-item-expositor">
                    PERCY RIVAS
                  </h4>
                  <p className="parrafo-item-expositor">
                    Experto en Experiencia del Usuario
                  </p>
                </div>
                <div className="item-expositor">
                  <div className="img-item-expositor">
                    <img src={alex} alt="" />
                  </div>
                  <h4 className="title-item-expositor">
                    ALEX ZEGARRA
                  </h4>
                  <p className="parrafo-item-expositor">
                    Emprendedor/<br className="visible-xs"></br>Empresario
                  </p>
                </div>
                <div className="item-expositor">
                  <div className="img-item-expositor">
                    <img src={ally} alt="" />
                  </div>
                  <h4 className="title-item-expositor">
                    ALLISON SILVA
                  </h4>
                  <p className="parrafo-item-expositor">
                    Directora Emprender Futuro
                  </p>
                </div>
              </div>

              <p className="p-parrafo">
                En este <strong>CURSO GRATUITO ONLINE</strong> te mostraremos varias técnicas y consejos que te ayudarán a
                mejorar tu plan de venta para el 2022 🕛
              </p>
            </div>
            <div className="div-content-form-registrate">
              <div className="content-form-registrate">
                <h4 className="h4-registrate">Accede Ahora &#8595;</h4>

                <Form
                  form={form}
                  name="basic"
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item
                    name="name"
                    className="form-item"
                    rules={
                      [
                        { required: true, message: 'Por favor ingresa tu nombre completo' },
                      ]
                    }
                  >
                    <Input placeholder="Nombre y Apellidos*" />
                  </Form.Item>
                  <Form.Item
                    name="email"
                    className="form-item"
                    rules={[
                      { required: true, message: 'Por favor ingresa tu correo' },
                      { type: "email", message: "No es un correo válido" },
                    ]}
                  >
                    <Input placeholder="Correo Electrónico*" type="email" />
                  </Form.Item>
                  <Form.Item
                    name="phonenumber"
                    className="form-item"
                    rules={[
                      { required: true, message: 'Por favor ingresa tu teléfono' },
                      //{ min: 8, message: "No es un número de teléfono válido" },
                      //{ max: 8, message: "No es un número de teléfono válido" },
                      {
                        pattern: new RegExp(/^[6,7]\d{7}$/i),
                        message: "No es un número de celular válido",
                      },
                    ]}
                  >
                    <Input placeholder="Teléfono*" type="number" />
                  </Form.Item>

                  <Form.Item
                    name="ciudad"
                    className="form-item"
                    rules={[
                      { required: true, message: 'Por favor ingresa tu nombre ciudad' },
                    ]}
                  >
                    <Input placeholder="Ciudad*" />
                  </Form.Item>
                  <Form.Item 
                    name="recaptcha" 
                    rules={[{ required: true, message: 'Por favor completa la prueba de seguridad' }]}
                  >
                    <Recaptcha
                      ref={recaptchaRef}
                      sitekey={googleRecaptchaConfig.sitekey}
                      render="explicit"
                      onloadCallback={() => {}}
                      verifyCallback={verifyCallback}
                      expiredCallback={expiredCallback}
                      hl= {'es'}
                      onChange={onChange}
                    />
                  </Form.Item>
                  {/** Hidden fields */}
                  <Form.Item name="utm_source" hidden={true}>
                    <Input/>
                  </Form.Item>
                  <Form.Item name="utm_campaign" hidden={true}>
                    <Input/>
                  </Form.Item>
                  <Form.Item name="utm_keyword" hidden={true}>
                    <Input/>
                  </Form.Item>
                  <Form.Item name="utm_medium" hidden={true}>
                    <Input/>
                  </Form.Item>
                  {/** !Hidden fields */}

                  <Form.Item className="centerButton"  style={{ marginBottom: 0 }}>
                    <Button
                      className="button-main button-orange"
                      htmlType="submit"
                      loading={loadingSubmit}
                    >
                      Acceder &raquo;
                    </Button>
                  </Form.Item>

                  <Modal
                    centered={true}
                    visible={isModalVisible}
                    onOk={handleOk}
                    closable={false}
                    footer={[
                      <Button
                        key="submit"
                        className="button-main button-blue"
                        onClick={handleOk}
                      >
                        Continuar &raquo;
                      </Button>,
                    ]}
                  >
                    <h4 className="title-modal">
                      ¡Bienvenido!
                    </h4>
                    <div className="image-modal">
                      <img src={_24e} alt="" />
                    </div>
                    <p className="parrafo-modal">
                      Ya puedes ingresar al CURSO GRATUITO ONLINE en el que aprenderás de <span>3 especialistas</span>{" "}
                      que te ayudarán en tu plan de ventas.
                    </p>
                    <p className="parrafo-modal">
                      También te enviamos un <span>enlace a tu correo electrónico</span>{" "}
                      con la información del curso.
                    </p>
                  </Modal>
                </Form>
              </div>
            </div>
            <p className="p-parrafo">&nbsp;</p>
            <p className="p-parrafo">
              Organizado por la <a href="https://emprenderfuturo.org">Fundación Emprender Futuro</a> con el apoyo de Banco de Crédito de Bolivia <strong>BCP</strong>.
            </p>
            <p className="p-parrafo">&nbsp;</p>
          </div>
        ) : (
          <VideoSection />
        )  
        }
      </div>
    </>
  );
}

export default App;
